import { render, staticRenderFns } from "./MaterialDownload.vue?vue&type=template&id=fdda6a8a&scoped=true"
import script from "./MaterialDownload.vue?vue&type=script&lang=js"
export * from "./MaterialDownload.vue?vue&type=script&lang=js"
import style0 from "./MaterialDownload.vue?vue&type=style&index=0&id=fdda6a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda6a8a",
  null
  
)

export default component.exports